import { put, select } from 'redux-saga/effects';
import { photoCaptureUploadAttachmentsAction, photoCaptureDataFailureAction } from '../actions';
import { getAttachmentInfoFromDamageDetection, getUpdatedAttachmentInfoFromDamageDetection, getErrorMessagesBasedOnStatusCode } from '../utilities';
import { getPhotoCaptureAttachmentInfo, getPhotoCaptureContextId, getPhotoCaptureCompanyCode, getPhotoCaptureDamageDetectionGetData } from '../selectors';
/**
 * Shared sub-saga that selects damage detection state, derives the
 * attachments that need uploading, and dispatches the upload action.
 * Yields nothing and returns early when no damage detection response
 * is present in state.
 *
 * Usage: `yield call(photoCaptureUploadDamageAttachmentsSaga);`
 */
export function* photoCaptureUploadDamageAttachmentsSaga() {
    try {
        const attachmentInfo = yield select(getPhotoCaptureAttachmentInfo);
        const contextId = yield select(getPhotoCaptureContextId);
        const companyCode = yield select(getPhotoCaptureCompanyCode);
        const damageDetectionResponse = yield select(getPhotoCaptureDamageDetectionGetData);
        if (!damageDetectionResponse) {
            return;
        }
        const updatedAttachmentInfoWithDamageDetection = getUpdatedAttachmentInfoFromDamageDetection(attachmentInfo || [], damageDetectionResponse);
        const damageAttachmentInfo = getAttachmentInfoFromDamageDetection(updatedAttachmentInfoWithDamageDetection, damageDetectionResponse);
        if (damageAttachmentInfo.length > 0) {
            yield put(photoCaptureUploadAttachmentsAction(damageAttachmentInfo, contextId, companyCode));
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        yield put(photoCaptureDataFailureAction(errorMessage));
    }
}
//# sourceMappingURL=photoCaptureUploadDamageAttachmentsSaga.js.map